function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 129.4" {...props}><g fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10"><path d="M95.8 2.3s8.4 47.6-20.1 78.7-72.4 36-72.4 36" /><path d="M12.2 127.2s-9.2-4.5-10.4-9.5c-1.2-5 7.7-9.5 7.7-9.5" /></g></svg>;
});